/**
 * Rewrites Supabase Storage URLs to use the image transformation
 * endpoint, which resizes/compresses on the fly and serves WebP
 * with long cache headers. Non-Supabase URLs are returned as-is.
 *
 * Example:
 *   /storage/v1/object/public/bucket/file.jpg
 *     -> /storage/v1/render/image/public/bucket/file.jpg?width=600&quality=70
 */
export function cdnImage(
  url: string | null | undefined,
  opts: { width?: number; height?: number; quality?: number; resize?: "cover" | "contain" } = {},
): string {
  if (!url) return "";
  // Only transform Supabase Storage object URLs
  if (!url.includes("/storage/v1/object/public/")) return url;

  const transformed = url.replace("/storage/v1/object/public/", "/storage/v1/render/image/public/");
  const params = new URLSearchParams();
  if (opts.width) params.set("width", String(opts.width));
  if (opts.height) params.set("height", String(opts.height));
  params.set("quality", String(opts.quality ?? 70));
  if (opts.resize) params.set("resize", opts.resize);
  return `${transformed}?${params.toString()}`;
}
